import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import { Provider } from './MetaApiCloudContext';
import { connectToMetaApi } from './meta-api-cloud-actions';
import { StreamingMetaApiConnectionInstance } from 'metaapi.cloud-sdk';
import { useAuth } from '../auth/auth-hooks';
import { Loading } from '../../shared/components/Loading';
import { Strategy, StrategyStatus, useStrategiesLazyQuery } from '../../shared/types/generated';

type MetaApiCloudProviderProp = {
  children: ReactNode;
};
export const MetaApiCloudProvider: React.FC<MetaApiCloudProviderProp> = (
  {
    children,
  }) => {
  const { user } = useAuth();
  const [connection, setConnection] = useState<
    StreamingMetaApiConnectionInstance | undefined
  >(undefined);
  const [brokerLoading, setBrokerLoading] = useState<boolean>(true);
  const [strategyLoading, setStrategyLoading] = useState<boolean>(true);

  const subscribeStrategyToMarket = useCallback(async (data: Strategy[]) => {
    for (const datum of data) {
      await connection?.subscribeToMarketData(datum?.symbol as string, []);
    }
    setStrategyLoading(false);
  }, [connection]);

  const [callStrategies] = useStrategiesLazyQuery({
    onCompleted: (data) => {
      const items = (data.strategies?.items || []) as Strategy[];

      if (connection) subscribeStrategyToMarket(items);
      else setStrategyLoading(false);
    },
  });

  const connectWithBroker = useCallback(async () => {
    const connectionToMetaApi = await connectToMetaApi(user?.meta_api_cloud_account);
    if (connectionToMetaApi) setConnection(connectionToMetaApi);
    callStrategies({
      variables: {
        where: {
          status: StrategyStatus.Active,
        },
      },
    });
    setBrokerLoading(false);
  }, [callStrategies, user?.meta_api_cloud_account]);

  useEffect(() => {
    if (user) {
      connectWithBroker();
    }
  }, [connectWithBroker, user]);


  if (brokerLoading) return (<Loading>Loading broker...</Loading>);
  if (strategyLoading) return (<Loading>Loading strategies...</Loading>);


  const values = {
    connection,
  };


  return <Provider value={values}>{children}</Provider>;
};
